<template>
  <fragment v-if="isShow">
    <slot></slot>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HideByAccess',
  props: {
    action: {
      type: String,
      default: null,
    },
    data: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isShow: false,
    }
  },
  computed: {
    ...mapGetters(['userData']),
  },
  created() {
    this.handleCan()
  },
  watch: {
    selectedCompany: {
      deep: true,
      handler: 'handleCan',
    },
  },
  methods: {
    handleCan() {
      if (this.action && this.data) {
        this.$authorizer
          .can(this.action, this.data, this.userData.UserID.toString())
          .then((isCan) => {
            this.isShow = !isCan
          })
      } else {
        this.isShow = true
      }
    },
  },
}
</script>
